(ns firebase.core
  (:require ["firebase/app" :as firebase :refer [initializeApp]]))

(goog-define ADMIN_SDK false)

(defmulti configuration 
  "Return a Firebase configuration value for key"
  (fn [key] key))

(defmethod configuration :default [key]
  (throw (js/Error. (str "Firebase configuration must be supplied defined using `(defmethod configuration " (pr-str key) "[_] ...)` by the app."))))

(defonce app
  (delay 
    (initializeApp 
      (clj->js 
        (configuration ::app)))))